'use client';

import dynamic from 'next/dynamic';
import { SIDEBAR_DEFAULT_WIDTH } from '@/state/askEllieSidebarState';

const AskEllieWidgetSidebar = dynamic(
  () =>
    import('./AskEllieWidgetSidebar').then((mod) => ({
      default: mod.AskEllieWidgetSidebar,
    })),
  {
    ssr: false,
    loading: () => (
      <div
        className="flex items-center justify-center h-full flex-shrink-0 bg-ds-surface-white border-l border-ds-border-subtlest"
        style={{ width: SIDEBAR_DEFAULT_WIDTH }}
      >
        <div className="ds-text-body-sm-medium text-ds-text-subtle">
          Loading...
        </div>
      </div>
    ),
  }
);

// Public wrapper kept named `AskEllieSidebarDynamic` for back-compat with
// `main-layout.tsx` consumers; the inner component is the renamed widget.
export { AskEllieWidgetSidebar as AskEllieSidebarDynamic };
